import { HttpContextToken, HttpInterceptorFn } from '@angular/common/http';
import { fromEvent } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

export const ABORT_SIGNAL = new HttpContextToken<AbortSignal | null>(() => null);

export const abortSignalInterceptor: HttpInterceptorFn = (req, next) => {
  const signal = req.context.get(ABORT_SIGNAL);
  if (!signal) return next(req);
  const abort$ = fromEvent(signal, 'abort');
  return next(req).pipe(takeUntil(abort$));
};
